// extracted by mini-css-extract-plugin
module.exports = {"PageHolder":"AddCourse_PageHolder__1U8FD","AddCourseToSite":"AddCourse_AddCourseToSite__3chWL","anime":"AddCourse_anime__1veYu","SelectCourse":"AddCourse_SelectCourse__3i3YF"};